import { UserManager, UserManagerSettings } from 'oidc-client-ts';

const userConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080/',
  client_id:
    import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'spvcockpit-login-service',
  redirect_uri: window.location.origin,
};

const UserManagerClient = new UserManager(userConfig);

export default UserManagerClient;
